import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AsyncServiceBase } from "@common/services/async-service-base";
import { GlobalTablesService } from "@common/services/global-tables-service";

// /// <reference types="@types/googlemaps" />
// import { MapsAPILoader } from '@agm/core';

import { NomWebServicesJson } from '@common/services/nom-web-services-json';
import { VisualStateService } from '@common/services/visual-state-service';
import { of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class MapService extends AsyncServiceBase {
    constructor(
        public globalTablesService: GlobalTablesService,
        // private mapsAPILoader: MapsAPILoader,
        public nomWebServicesJson: NomWebServicesJson,
        public visualStateService: VisualStateService,
        private httpClient: HttpClient
    ) {
        super();
        this.globalTablesService.globalTablesLoaded.subscribe(() => {
            this.loadGoogleMapsAndResolve();
        });
    }

    public async loadGoogleMapsAndResolve(): Promise<any> {
        if (!(typeof google === 'object' && typeof google.maps === 'object')) {
            const result = await this.httpClient.jsonp(`https://maps.googleapis.com/maps/api/js?key=${this.visualStateService.ConfigSettings["LocationSettings"]}&libraries=places`, 'callback').toPromise();
        }

        if (this.visualStateService.ConfigSettings["LocationSettings"]) {
            this.autocomplete.service = new google.maps.places.AutocompleteService();
            this.autocomplete.places = new google.maps.places.PlacesService(<HTMLDivElement>document.getElementById("map"));
            this.googlemapsLoaded = true;
        }
        this.initializeResolve();
        // (<any>this.mapsAPILoader)._config.apiKey = this.visualStateService.ConfigSettings["LocationSettings"];
        // (<any>this.mapsAPILoader)._config.libraries = ["places"];

    }

    private googlemapsLoaded = false;
    public autocomplete: { service: google.maps.places.AutocompleteService, places: google.maps.places.PlacesService } = {
        service: null,
        places: null
    };

    public getAutocomplete(): Promise<{ service: google.maps.places.AutocompleteService, places: google.maps.places.PlacesService }> {
        let ret = new Promise<{ service: google.maps.places.AutocompleteService, places: google.maps.places.PlacesService }>((resolve, reject) => {
            if (this.googlemapsLoaded) {
                resolve(this.autocomplete);
            } else {
                if (this.visualStateService.ConfigSettings["LocationSettings"]) {
                    // this.mapsAPILoader.load().then(() => {
                    //     this.autocomplete.service = new google.maps.places.AutocompleteService();
                    //     this.autocomplete.places = new google.maps.places.PlacesService(<HTMLDivElement>document.getElementById("map"));
                    //     this.googlemapsLoaded = true;
                    //     resolve(this.autocomplete);
                    // }).catch((err) => {
                    //     reject(err);
                    // });
                    // this.httpClient.jsonp(`https://maps.googleapis.com/maps/api/js?key=${this.visualStateService.ConfigSettings["LocationSettings"]}&libraries=places`, 'callback')
                    // .pipe(
                    //     //take(1),
                    //     map(() => {
                    //         if (this.visualStateService.ConfigSettings["LocationSettings"]) {
                    //             this.autocomplete.service = new google.maps.places.AutocompleteService();
                    //             this.autocomplete.places = new google.maps.places.PlacesService(<HTMLDivElement>document.getElementById("map"));
                    //             this.googlemapsLoaded = true;
                    resolve(this.autocomplete);
                    //         }

                    //         this.initializeResolve();
                    //     }),
                    //     catchError((err) => of(reject(err))),
                    // ).subscribe();
                } else {
                    resolve(this.autocomplete);
                }
            }
        });

        return ret;
    }
}
